(function () {
  'use strict';

  var newArrivalsHash = '#new-arrivals';
  var activeNavClasses = ['is-active', 'site-nav--active', 'active', 'current'];
  var navSelector = [
    '[data-lukzer-nav-item="home"]',
    '[data-lukzer-nav-item="new-arrivals"]',
    '.lukzer-header-nav__item',
    '.site-nav > li'
  ].join(',');
  var newArrivalsObserver = null;

  function updateAnchorOffset() {
    var offset = 16;
    document.querySelectorAll('.site-header, #header-sticky').forEach(function (header) {
      var style = window.getComputedStyle(header);
      var rect = header.getBoundingClientRect();
      if (style.display !== 'none' && style.visibility !== 'hidden' && rect.height > 0 && rect.top <= 1) {
        offset = Math.max(offset, rect.bottom + 16);
      }
    });
    document.documentElement.style.setProperty('--lukzer-anchor-offset', Math.ceil(offset) + 'px');
  }

  function scrollToNewArrivals(updateHistory) {
    var target = document.getElementById('new-arrivals');
    if (!target) return false;
    updateAnchorOffset();
    setHomepageNavState('new-arrivals');
    target.scrollIntoView({
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      block: 'start'
    });
    if (updateHistory && window.location.hash !== newArrivalsHash) {
      window.history.pushState(null, '', newArrivalsHash);
    }
    return true;
  }

  function isHomepage() {
    var path = window.location.pathname.replace(/\/+$/, '') || '/';
    return path === '/';
  }

  function navItemKey(item) {
    if (!item) return '';
    if (item.dataset && item.dataset.lukzerNavItem) return item.dataset.lukzerNavItem;
    var link = item.querySelector('a[href]');
    if (!link) return '';
    var label = (link.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
    var href = link.getAttribute('href') || '';
    if (label === 'new arrivals' || href.indexOf('#new-arrivals') !== -1) return 'new-arrivals';
    if (label === 'home') return 'home';
    return '';
  }

  function setItemActive(item, active) {
    if (!item) return;
    var usesCustomClass = item.classList.contains('lukzer-header-nav__item');
    activeNavClasses.forEach(function (className) {
      item.classList.remove(className);
    });
    if (active) item.classList.add(usesCustomClass ? 'is-active' : 'site-nav--active');
    var link = item.querySelector('a[href]');
    if (link) {
      if (active) link.setAttribute('aria-current', 'page');
      else link.removeAttribute('aria-current');
    }
  }

  function setHomepageNavState(activeKey) {
    if (!isHomepage()) return;
    document.querySelectorAll(navSelector).forEach(function (item) {
      var key = navItemKey(item);
      if (key === 'home' || key === 'new-arrivals') {
        setItemActive(item, key === activeKey);
      }
    });
  }

  function resetHomepageNavFromPosition() {
    if (!isHomepage()) return;
    var target = document.getElementById('new-arrivals');
    var rect = target && target.getBoundingClientRect();
    var top = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--lukzer-anchor-offset')) || 100;
    var visibleHeight = rect ? Math.max(0, Math.min(rect.bottom, window.innerHeight * .8) - Math.max(rect.top, top)) : 0;
    var meaningfulHeight = rect ? Math.min(rect.height * .18, Math.max(1, window.innerHeight * .8 - top) * .3) : 1;
    setHomepageNavState(rect && rect.height > 0 && visibleHeight >= meaningfulHeight ? 'new-arrivals' : 'home');
  }

  function initNewArrivalsNavObserver() {
    if (!isHomepage()) return;
    if (newArrivalsObserver) {
      newArrivalsObserver.disconnect();
      newArrivalsObserver = null;
    }
    var target = document.getElementById('new-arrivals');
    if (!target || !('IntersectionObserver' in window)) {
      resetHomepageNavFromPosition();
      return;
    }

    var top = Math.ceil(parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--lukzer-anchor-offset')) || 100);
    var targetHeight = target.getBoundingClientRect().height;
    var meaningfulRatio = Math.min(.18, Math.max(1, window.innerHeight * .8 - top) * .3 / Math.max(1, targetHeight));
    newArrivalsObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        setHomepageNavState(entry.isIntersecting && entry.intersectionRatio >= meaningfulRatio ? 'new-arrivals' : 'home');
      });
    }, {
      root: null,
      threshold: [0, meaningfulRatio],
      rootMargin: '-' + top + 'px 0px -20% 0px'
    });
    newArrivalsObserver.observe(target);
    resetHomepageNavFromPosition();
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('a[data-new-arrivals-link], a[href="/#new-arrivals"]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    var destination = new URL(link.href, window.location.href);
    var currentPath = window.location.pathname.replace(/\/+$/, '') || '/';
    var destinationPath = destination.pathname.replace(/\/+$/, '') || '/';
    if (destination.origin === window.location.origin && destinationPath === '/') {
      setHomepageNavState('new-arrivals');
    }
    if (destination.origin === window.location.origin && currentPath === destinationPath && scrollToNewArrivals(true)) {
      event.preventDefault();
    }
  });

  function handleInitialNewArrivalsHash() {
    if (window.location.hash === newArrivalsHash) {
      setHomepageNavState('new-arrivals');
      window.requestAnimationFrame(function () { scrollToNewArrivals(false); });
    } else {
      resetHomepageNavFromPosition();
    }
  }

  var sliderSelector = [
    '[data-lz-slider]', '.slick-slider', '.main-slider', '.nov-slick-carousel',
    '.swiper', '.swiper-container', '.nov-swiper-carousel', '.carousel', '.slideshow'
  ].join(',');
  var cardSelector = [
    '.card', '.product-card', '.collection-card', '.category-card',
    '.item-product', '.product--item', '[data-product-card]'
  ].join(',');
  var revealSelector = '.animate-on-scroll, .scroll-trigger, .reveal, [data-scroll-reveal], [data-aos], .wow';
  var hoverSelector = [
    '.product-card__image--secondary', '.secondary-image',
    '.product__thumbnail-second', '[data-hover-image]'
  ].join(',');

  function preloadHoverImage(image) {
    if (!image || image.dataset.lzPreloaded === 'true') return;
    var source = image.currentSrc || image.dataset.src || image.getAttribute('src');
    if (!source) return;
    image.dataset.lzPreloaded = 'true';
    var preload = new Image();
    preload.decoding = 'async';
    preload.src = source;
  }

  function stabilizeImage(image) {
    if (image.dataset.lzImageReady === 'true') return;
    image.dataset.lzImageReady = 'true';
    image.decoding = 'async';

    if (!image.hasAttribute('width') && image.naturalWidth) image.width = image.naturalWidth;
    if (!image.hasAttribute('height') && image.naturalHeight) image.height = image.naturalHeight;
    if ((!image.hasAttribute('width') || !image.hasAttribute('height')) && !image.complete) {
      image.addEventListener('load', function setIntrinsicSize() {
        if (!image.hasAttribute('width') && image.naturalWidth) image.width = image.naturalWidth;
        if (!image.hasAttribute('height') && image.naturalHeight) image.height = image.naturalHeight;
      }, { once: true });
    }
  }

  function pauseSliderWhenHidden(slider) {
    if (slider.dataset.lzVisibilityObserved === 'true' || !('IntersectionObserver' in window)) return;
    slider.dataset.lzVisibilityObserved = 'true';
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var element = entry.target;
        if (element.swiper && element.swiper.autoplay) {
          if (entry.isIntersecting) element.swiper.autoplay.start();
          else element.swiper.autoplay.stop();
        }
        if (window.jQuery && jQuery.fn.slick && jQuery(element).hasClass('slick-initialized')) {
          jQuery(element).slick(entry.isIntersecting ? 'slickPlay' : 'slickPause');
        }
      });
    }, { rootMargin: '160px 0px' });
    observer.observe(slider);
  }

  function initLukzerSection(root) {
    var scope = root && root.querySelectorAll ? root : document;

    scope.querySelectorAll('img').forEach(stabilizeImage);

    scope.querySelectorAll(cardSelector).forEach(function (card) {
      if (card.dataset.lzHoverReady === 'true') return;
      card.dataset.lzHoverReady = 'true';
      card.querySelectorAll(hoverSelector).forEach(preloadHoverImage);
    });

    scope.querySelectorAll(revealSelector).forEach(function (element) {
      element.classList.add('is-revealed');
      element.dataset.lzInitialized = 'true';
    });

    scope.querySelectorAll(sliderSelector).forEach(function (slider) {
      slider.dataset.lzInitialized = 'true';
      pauseSliderWhenHidden(slider);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initLukzerSection(document);
      updateAnchorOffset();
      handleInitialNewArrivalsHash();
      initNewArrivalsNavObserver();
    }, { once: true });
  } else {
    initLukzerSection(document);
    updateAnchorOffset();
    handleInitialNewArrivalsHash();
    initNewArrivalsNavObserver();
  }

  window.addEventListener('load', handleInitialNewArrivalsHash, { once: true });
  window.addEventListener('hashchange', function () {
    handleInitialNewArrivalsHash();
    initNewArrivalsNavObserver();
  });

  document.addEventListener('shopify:section:load', function (event) {
    initLukzerSection(event.target);
    initNewArrivalsNavObserver();
  });

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      updateAnchorOffset();
      initNewArrivalsNavObserver();
      document.dispatchEvent(new CustomEvent('lukzer:resize:stable'));
    }, 150);
  }, { passive: true });

  window.LukzerStability = { init: initLukzerSection };
})();
